import {useUpmPlantsContext} from '@hconnect/upm'
import {Navigate, useParams} from 'react-router'

import {getUrl, ROUTES} from '../../routing'
import {PageSkeleton} from '../components/skeletons'

export const SuiteHierarchyRedirect: React.FC = () => {
  const {hierarchyId} = useParams<{hierarchyId: string}>()
  const upmPlants = useUpmPlantsContext({isInitialLoad: true})

  if (!upmPlants) {
    return <PageSkeleton />
  }

  const resolvedPlant = hierarchyId
    ? Object.values(upmPlants).find((plant) => plant.upmId === hierarchyId)
    : undefined

  if (!resolvedPlant) {
    return <Navigate to={ROUTES.BASE.PLANT_SELECTOR.path} replace />
  }

  return (
    <Navigate
      to={getUrl(ROUTES.BASE.PLANT_SELECTOR.PLANT.path, {plantCode: resolvedPlant.plantId})}
      replace
    />
  )
}
